module.exports = __webpack_public_path__ + "static/img/banner1.97bc3284.jpg";